const ROOTS = {
  AUTH: '/auth',
  AUTH_DEMO: '/auth-demo',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  page403: '/error/403',
  page404: '/error/404',
  page500: '/error/500',
  termsAndConditions: '/terms-and-conditions',
  privacyPolicy: '/privacy-policy',
  dataDeletion: '/data-deletion',
  // AUTH
  auth: {
    jwt: {
      login: `${ROOTS.AUTH}/jwt/sign-in`,
      register: `${ROOTS.AUTH}/jwt/sign-up`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    account: '/dashboard',
    chat: '/dashboard/chat',
    messages: '/messages',
    automations: {
      root: '/dashboard/automations',
      new: '/dashboard/automations/new',
      list: '/dashboard/automations/list',
      edit: (id) => `/dashboard/automations/${id}/edit`,
    },
  },
};
